import { GET } from "./";
export const typeAccount = {
  getActives: () => GET(`/api/typeAccount/actives`)
};
